export interface RfqDetailsTabConfig {
  id :string;
  label :string;
  icon :string;
  index ?:number;
  permissions ?:string[];
}

export const RFQ_DETAILS_TABS :RfqDetailsTabConfig[] = [
  { id: 'details', label: 'RFQ.DETAILS', icon: 'fas fa-stream' },
  { id: 'substitutions', label: 'Product Substitutions', icon: 'fas fa-stream' },
  { id: 'kit-items', label: 'Kit Items', icon: 'fas fa-stream' },
  { id: 'variants', label: 'Product Variants', icon: 'fas fa-stream' },
  { id: 'attachments', label: 'Attachments', icon: 'fas fa-file' },
  { id: 'pricing', label: 'Pricing', icon: 'fas fa-calculator' },
  { id: 'quotations', label: 'RFQ.QUOTATIONS', icon: 'fas fa-file-invoice' },
  { id: 'messages', label: 'RFQ.MESSAGES', icon: 'fas fa-comments' },
  { id: 'sales', label: 'Sales', icon: 'fas fa-chart-line' },
  {
    id: 'costs',
    label: 'Costs',
    icon: 'fas fa-dollar-sign',
    permissions: ['skuUnitCost.read'],
  },
  { id: 'unit-conversions', label: 'Unit Conversions', icon: 'fas fa-dollar-sign' },
  { id: 'cogs-margin', label: 'COGS / Margin', icon: 'fas fa-dollar-sign' },
  { id: 'qty-logs', label: 'Qty Logs', icon: 'fas fa-file' },
  { id: 'supplier-skus', label: 'Supplier SKUs', icon: 'fas fa-truck' },
];
